import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import API from '@Services/apiAxios';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export interface Warehouse {
  _id: string;
  company_name: string;
  id: string;
}

export interface WarehouseResponse {
  msg: string;
  isError: boolean;
  isFetched: boolean;
  data: {
    list: Warehouse[];
  };
  totalCount: number;
}

export const LogisticsOptions: DropdownOptionType[] = [
  { value: 'delhivery', display: 'Delhivery' },
  { value: 'bluedart', display: 'Bluedart' },
  { value: 'xpressbees', display: 'Xpressbees' },
  { value: 'ecom', display: 'Ecom' },
  { value: 'ekart', display: 'Ekart' },
];

export const PaymentModeOptions: DropdownOptionType[] = [
  { value: 'cod', display: 'COD' },
  { value: 'prepaid', display: 'Prepaid' },
];

export const ServiceTypeOptions: DropdownOptionType[] = [
  { value: 'air', display: 'Air' },
  { value: 'surface', display: 'Surface' },
];

export const OrderTypeOptions: DropdownOptionType[] = [
  { value: 'forward', display: 'Forward' },
  { value: 'reverse', display: 'Reverse' },
];

export const PickupAddressOptions: DropdownOptionType[] = [{ value: '39898', display: 'Testing Pickup Address' }];

export const getWarehouses = async (accountNo: string): Promise<DropdownOptionType[]> => {
  try {
    const response = await API.get<WarehouseResponse>(
      `/shipment/vendor/ithinklogistics/warehouses?accountNo=${accountNo}`,
    );

    const warehouses = response.data.data.list;

    const PickupAddressOptions: DropdownOptionType[] = warehouses.map(item => ({
      value: item.id,
      display: `${item.id} - ${item.company_name}`,
    }));

    return PickupAddressOptions;
  } catch (error) {
    console.error('Failed to fetch warehouses', error);
    return [];
  }
};

export const addWarehouse = async (props: { accountNo: string; shipmentNumber: string }): Promise<void> => {
  try {
    const response = await API.post(`/shipment/vendor/ithinklogistics/addwarehouses/${props?.shipmentNumber}`, {
      accountNo: props.accountNo,
    });

    if (response.data.isError) {
      throw new Error(response.data.msg);
    }

    console.log('Warehouse added successfully:', response.data.msg);
  } catch (error) {
    console.error('Failed to add warehouse', error);
    throw error;
  }
};

export const IThinkLogisticsDomesticInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  pickup_address_id: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Warehouse address is required'),
  logistics: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Logistics is required'),
  order_type: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Order type is required'),
  s_type: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Service type is required'),
  payment_mode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Payment mode is required'),
});

export interface IThinkLogisticsDomesticInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  pickup_address_id: string;
  logistics: string;
  order_type: string;
  s_type: string;
  payment_mode: string;
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: IThinkLogisticsDomesticInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  body.csp = 'ithink_logistics_domestic';
  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }
  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
